import { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { ExternalLink } from 'lucide-react';
import { api } from '@/lib/api.js';
import { MembersTab } from '@/features/admin/MembersTab.js';
import { AiTab } from '@/features/admin/AiTab.js';
import { PageLayout } from '@/components/layout/PageLayout.js';

const HAOPS_CONTEUDO_URL = 'https://os.hack.net.br/ha/conteudo';

type Tab = 'membros' | 'ia';

export function ConfiguracoesPage() {
  const me = useQuery({
    queryKey: ['me'],
    queryFn: async () => (await api.get('/auth/me')).data as { role: string },
  });
  const [tab, setTab] = useState<Tab>('membros');

  if (me.isLoading) return <p className="text-ha-muted">Carregando…</p>;
  if (me.data?.role !== 'ADMIN' && me.data?.role !== 'SUPER_ADMIN') {
    return <Navigate to="/inicio" replace />;
  }

  const tabs: { id: Tab; label: string }[] = [
    { id: 'membros', label: 'Membros' },
    { id: 'ia', label: 'IA' },
  ];

  return (
    <PageLayout
      title="Configurações"
      description="Membros e IA no Academy. Trilhas, eventos e provisionamento comercial: HAOps no HackOS (DEC-003)."
    >
      <div className="mb-6 rounded-xl border border-accent/30 bg-accent/5 p-4 text-sm text-ha-fg">
        <p className="font-semibold">Operação pedagógica no HackOS</p>
        <p className="mt-1 text-ha-muted">
          Conteúdo, alunos (CSC), eventos e certificados são geridos em{' '}
          <strong>HAOps</strong>, não nesta tela.
        </p>
        <a
          href={HAOPS_CONTEUDO_URL}
          target="_blank"
          rel="noreferrer"
          className="mt-3 inline-flex items-center gap-1.5 text-xs font-bold text-accent hover:underline"
        >
          Abrir HAOps — Conteúdo
          <ExternalLink className="h-3.5 w-3.5" />
        </a>
      </div>

      <div className="mb-6 flex gap-2 border-b border-ha-border">
        {tabs.map((t) => (
          <button
            key={t.id}
            type="button"
            className={`px-4 py-2 text-xs font-bold uppercase ${tab === t.id ? 'border-b-2 border-accent text-accent' : 'text-ha-muted'}`}
            onClick={() => setTab(t.id)}
          >
            {t.label}
          </button>
        ))}
      </div>
      {tab === 'membros' ? <MembersTab /> : <AiTab />}
    </PageLayout>
  );
}
